import React, { useState, useContext } from 'react';
import useAnalytics from 'helpers/useAnalytics';
import _remove from 'lodash/remove';
import _get from 'lodash/get';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import makeStyles from '@material-ui/core/styles/makeStyles';
import SourceContext from 'helpers/SourceContext';
import useSource from 'pages/Directory/helpers/useSource';
import makeGetSource from 'fetches/makeGetSource';
import makeSourceCreateBaseUrl from 'pages/Directory/helpers/makeSourceCreateBaseUrl';
import makeUpdateSource from 'fetches/makeUpdateSource';

// Components
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Chip from '@material-ui/core/Chip';
import GroupsAutosuggest from 'pages/Directory/SelectGroups/GroupsAutosuggest';

import Base from 'pages/Directory/Base';

import { MAP_ATTRIBUTES_URL } from 'pages/Directory/consts';

function SelectGroups() {
  const classes = useStyles();
  const analytics = useAnalytics();
  const history = useHistory();
  const dispatch = useDispatch();
  const sourceContext = useContext(SourceContext);
  const { sourceInfo } = sourceContext;
  const { directoryId, sourceId, type } = sourceInfo;
  const source = useSource(sourceId);
  const getSource = makeGetSource(sourceId);
  const baseUrl = makeSourceCreateBaseUrl(directoryId, sourceId);
  const initialGroups = _get(source, 'groups', []);
  const [groups, setGroups] = useState<any[]>(initialGroups);
  const updateSource = makeUpdateSource(sourceId);
  const sourceCopy = sourceInfo.type === 'azure-active-directory' ? 'AAD' : 'Google Workspace';

  const handleNext = async () => {
    history.push(`${baseUrl}${MAP_ATTRIBUTES_URL}`);
    await dispatch(updateSource({ ...source, groups }));
    await dispatch(getSource());

    analytics.track('Wizard - Groups Step Completed', {
      category: 'AD - Directories',
      label: type,
    });
  };

  const handleSelect = (group: any) => {
    const alreadyExists = groups.find((g: any) => g.id === group.id);

    if (!alreadyExists) {
      const newGroups = [...groups, group];
      setGroups(newGroups);
    }
  };

  const handleDeleteTag = (groupId: string) => {
    const updatedGroups = _remove(groups, g => g.id !== groupId);
    setGroups(updatedGroups);
  };

  return (
    <Base onNext={handleNext} currentStep={2}>
      <CardHeader
        className={classes.header}
        title={'Set Groups to Sync'}
        subheader={`Select which groups of ${sourceCopy} Users to bring into Sift. If not provided, all users in your tenant will be imported. This can be changed later.`}
      />
      <CardContent>
        <div className={classes.groupSearchContainer}>
          <GroupsAutosuggest sourceId={sourceId} onSelect={handleSelect} />
        </div>
        <div>
          {groups.map((group: any) => {
            return (
              <Chip
                className={classes.chip}
                onDelete={() => {
                  handleDeleteTag(group.id);
                }}
                label={group.displayName}
                key={group.id}
              />
            );
          })}
        </div>
      </CardContent>
    </Base>
  );
}

const useStyles = makeStyles(theme => ({
  header: {
    marginLeft: theme.spacing(0.75),
  },
  groupSearchContainer: {
    display: 'flex',
    marginBottom: theme.spacing(1),
  },
  chip: {
    margin: theme.spacing(0.5),
    display: 'inline-flex',
    '& svg': {
      fill: `${theme.palette.common.white} !important`,
    },
  },
}));

export default SelectGroups;
